export type ListingStatus = "ready" | "noResults" | "empty" | "error";

export interface ListingRefinements {
	refinementList?: Record<string, string[]>;
	toggle?: Record<string, boolean>;
	range?: Record<string, string>;
}

export function hasRefinements({
	refinementList = {},
	toggle = {},
	range = {}
}: ListingRefinements): boolean {
	return (
		Object.values(refinementList).some((values) => values.length > 0) ||
		Object.values(toggle).some(Boolean) ||
		Object.values(range).some((value) => Boolean(value) && value !== ":")
	);
}

export function listingStatus({
	count,
	filtered,
	failed
}: {
	count: number;
	filtered: boolean;
	failed: boolean;
}): ListingStatus {
	if (failed) return "error";
	if (count > 0) return "ready";
	return filtered ? "noResults" : "empty";
}
